<template>
  <div>{{ data?.title }}</div>
</template>

<script setup lang="ts">
import { createError } from '#imports'

import { useCMSHead } from '~/scopes/cms/composables/useCMSHead'
import { useFetchCMSPageContent } from '~/scopes/cms/composables/useFetchCMSPageContent'

const { data, error } = await useFetchCMSPageContent({
  fetchFallbackOnError: false,
})

if (error.value) {
  throw createError({
    statusCode: error.value.statusCode,
    statusMessage: error.value.message,
    fatal: true,
  })
}

useCMSHead(data)
</script>
